module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-center__and__page_break"
  }, [_c('span', [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "",
      "src": "OPS/image0.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-center__and__page_break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Foto: David Schmidt")])]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-center__and__page_break"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-center__and__page_break"
  }, [_c('span', [_vm._v("Für Dunkyn und Dolan")])]), _vm._v(" "), _c('p', {
    staticClass: "p_norm-center__and__page_break"
  }, [_c('span', [_vm._v("Danke, dass ihr euer Leben mit mir geteilt und mir so viel gegeben habt.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b7042e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0003.vue
// module id = 63
// module chunks = 0